import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import IconWrapper from './IconWrapper'

const MailIcon = ({ color = '#434341', width, display, transform }) => (
  <IconWrapper
    width={width}
    height="100%"
    display={display}
    transform={transform}>
    <svg width="100%" height="100%" viewBox="0 0 12 10" fill="none">
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.91169 1.19201L6.14529 4.36721C6.18406 4.39629 6.23122 4.41201 6.27969 4.41201C6.32815 4.41201 6.37531 4.39629 6.41409 4.36721L10.6477 1.19201H1.91169ZM11.2077 1.61201L6.81729 4.90481C6.66219 5.02113 6.47356 5.08401 6.27969 5.08401C6.08582 5.08401 5.89718 5.02113 5.74209 4.90481L1.35169 1.61201V8.80801H11.2077V1.61201ZM1.23969 0.520006H11.3197C11.4682 0.520006 11.6106 0.579006 11.7157 0.684026C11.8207 0.789047 11.8797 0.931485 11.8797 1.08001V8.92001C11.8797 9.06853 11.8207 9.21097 11.7157 9.31599C11.6106 9.42101 11.4682 9.48001 11.3197 9.48001H1.23969C1.09117 9.48001 0.948728 9.42101 0.843708 9.31599C0.738687 9.21097 0.679688 9.06853 0.679688 8.92001V1.08001C0.679688 0.931485 0.738687 0.789047 0.843708 0.684026C0.948728 0.579006 1.09117 0.520006 1.23969 0.520006Z"
      />
    </svg>
  </IconWrapper>
)

MailIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  display: PropTypes.string,
  transform: PropTypes.string,
}

MailIcon.defaultProps = {
  color: theme.colors.coaldark,
  width: [],
  display: 'inline-block',
  transform: 'rotate(0)',
}

export default MailIcon
